<template>
  <div class="lich-su">
    <div v-if="loading" class="loading-container">
      <div class="spinner"></div>
      <span class="loading-text">Đang tải lịch sử...</span>
    </div>
    <div v-else>
      <div class="title">Hãy vui lên vì mỗi lần đóng học phí, chúng ta sẽ trưởng thành hơn 😆</div>
      <div
        v-for="(item, index) in historyList.slice(0, 50)"
        :key="item.betId"
        class="bet-row"
      >
        <div
          class="players"
          :class="{ 'single-player': !item.playerId2 }"
        >
          <div class="player-tag">
            <img :src="item.Player1.Avatar" alt="avatar1" class="avatar" />
            <span>{{ item.Player1.Name }}</span>
          </div>
          <div
            v-if="item.playerId2"
            class="player-tag"
          >
            <img :src="item.Player2.Avatar" alt="avatar2" class="avatar" />
            <span>{{ item.Player2.Name }}</span>
          </div>
        </div>
        <div class="info">
          <span class="date">{{ formatDate(item.betDate) }}</span>
          <span class="amount">{{ item.betAmount }}K</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LichSu",
  data() {
    return {
      historyList: [],
      loading: true,
    };
  },
  async mounted() {
    try {
      const res = await fetch("https://script.google.com/macros/s/AKfycbx4On0Fs2eKWdPyCS_SnIGvzuwdU6oTMYEYDxhUR5UTub5-NzzJoiDXv92H1nCU5sKPrw/exec?action=getBetHistory");
      const bets = await res.json();

      if (!Array.isArray(bets)) {
        console.error("Dữ liệu getBetHistory trả về không hợp lệ:", bets);
        return;
      }

      const res2 = await fetch("https://script.google.com/macros/s/AKfycbx4On0Fs2eKWdPyCS_SnIGvzuwdU6oTMYEYDxhUR5UTub5-NzzJoiDXv92H1nCU5sKPrw/exec?action=getPlayerList");
      const text = await res2.text();

      try {
        const players = JSON.parse(text);

        if (!Array.isArray(players) || players.length === 0 || !players[0].playerId) {
          console.error("❌ Dữ liệu getPlayerList trả về thiếu dữ liệu cần thiết:", players);
          throw new Error("Thiếu dữ liệu playerId trong playerList");
        }

        const playerMap = {};
        players.forEach(p => {
          const id = String(p.playerId);
          if (!id || !p.playerName || !p.playerAvatar) {
            console.warn("⚠️ Player thiếu thông tin:", p);
            return;
          }
          playerMap[id] = {
            Name: p.playerName,
            Avatar: p.playerAvatar,
          };
        });

        this.historyList = bets.map(bet => {
          let isoDate = '';
          if (typeof bet.betDate === 'string' && bet.betDate.includes('/')) {
            const [day, month, year] = bet.betDate.split('/');
            isoDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
          } else {
            isoDate = bet.betDate;
          }
          return {
            ...bet,
            betDateISO: isoDate,
            Player1: playerMap[String(bet.playerId1)] || { Name: "?", Avatar: "" },
            Player2: playerMap[String(bet.playerId2)] || { Name: "?", Avatar: "" },
          };
        }).sort((a, b) => new Date(b.betDateISO) - new Date(a.betDateISO));
      } catch (jsonErr) {
        console.error("❌ JSON.parse lỗi hoặc không phải JSON chuẩn:", jsonErr, "\nText raw:", text);
      }
    } catch (err) {
      console.error("Lỗi khi fetch dữ liệu lịch sử:", err);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    formatDate(dateStr) {
      const d = new Date(dateStr);
      if (isNaN(d)) return dateStr;

      const weekdays = ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'];
      const dayOfWeek = weekdays[d.getDay()]; // 0 = CN, 1 = T2, ...

      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();

      return `${dayOfWeek} - ${day}/${month}/${year}`;
    }
  },
};
</script>

<style scoped>
.lich-su {
  padding: 16px;
  font-family: sans-serif;
  max-width: 400px;
  margin: 0 auto;
  font-size: 15px;
  /* overflow-x: hidden; */
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  gap: 10px;
}

.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #4caf50;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.title {
  text-align: center;
  font-weight: 550;
  font-size: 15px;
  margin-bottom: 12px;
  color: #222;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  line-height: 1.6;
}

.bet-row {
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #aaaaaa;
  padding: 15px 0;
  gap: 5px;
}

.players {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  gap: 8px;
  flex: 1;
}

.player-tag {
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 999px;
  padding: 2px 5px;
  gap: 6px;
  justify-content: center;
  height: 50px;
  width: 80px;
}

.avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
}

.info {
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: bold;
  font-size: 14px;
  flex-shrink: 0;
  min-width: 120px;
  text-align: right;
}

.date {
  color: #000000;
  min-width: 80px;
  text-align: right;
  padding-right: 4px;
  font-weight: 550;
}

.amount {
  color: #000;
  min-width: 40px;
  text-align: right;
  font-size: 18px;
  color: rgb(223, 31, 31);
}

.loading-text {
  color: #666;
  font-size: 14px;
  font-weight: 500;
}

.players.single-player {
  justify-content: center;
  padding-right: 55px;
}

</style>
@media (max-width: 400px) {
  .bet-row {
    flex-wrap: wrap;
  }

  .info {
    width: 100%;
    justify-content: flex-end;
    margin-top: 6px;
  }

  .players {
    flex-wrap: wrap;
  }
}

.lich-su {
  overflow-x: auto;
}

.bet-row {
  min-width: 360px;
}